// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-copyright[data-v-634d8877]{padding-left:var(--padding-xl);padding-right:var(--padding-xl)}@media(min-width:1200px){.footer-copyright[data-v-634d8877]{padding-left:var(--padding-3xl)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
